import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-inputgroup mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", {
  class: "p-inputgroup-addon font-semibold general-label-color",
  style: {"min-width":"5rem"}
}, "Email", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-error p-0 m-0 pl-2" }
const _hoisted_6 = {
  key: 1,
  class: "field-checkbox align-items-start mt-3 mb-2 pl-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "show-model-number" }, "Show Model Number", -1)
const _hoisted_8 = {
  key: 2,
  class: "field-checkbox align-items-start ml-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "show-prices" }, "Show Prices", -1)
const _hoisted_10 = { class: "flex justify-content-end p-0 m-0" }
const _hoisted_11 = { class: "p-0 m-0" }
const _hoisted_12 = { class: "p-0 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.dialogTitle(),
    visible: _ctx.visible,
    modal: true,
    closable: false,
    class: "w-9 lg:w-4 xl:w-3"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            label: "Cancel",
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.closeSendEmailDialog
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            label: "Send",
            icon: "pi pi-check",
            disabled: !_ctx.emailToSend || _ctx.v$.emailToSend.$invalid,
            onClick: _ctx.handleSendEmail,
            loading: _ctx.loading
          }, null, 8, ["disabled", "onClick", "loading"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            id: "email-to-send",
            modelValue: _ctx.emailToSend,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailToSend) = $event)),
            class: _normalizeClass({ 'text-sm p-invalid': _ctx.v$.emailToSend.email.$invalid}),
            placeholder: "Enter your email...",
            type: "email"
          }, null, 8, ["modelValue", "class"])
        ]),
        (_ctx.v$.emailToSend.email.$invalid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.v$.emailToSend.email.$message), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showModelsCheckbox)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Checkbox, {
                id: "show-model-number",
                modelValue: _ctx.showModelNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModelNumber) = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        (_ctx.showPricesCheckbox)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_Checkbox, {
                id: "show-prices",
                modelValue: _ctx.showPrices,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPrices) = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_9
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}